import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core";


const MaterialCircle = withStyles((theme) => ({
  root: {
    color: theme.custom.brand.primary
  }
}))(CircularProgress);

export default MaterialCircle;
